export const USERS = '/users'
export const USERS_GET = '/users/get'
export const USER_BILLING_DETAILS = '/users/billing'
export const USERS_CREATE = '/users/create'
export const USERS_AND_PATIENTS = '/users/patients'
export const USER_BILLING_STATEMENT = 'users/download-billing-statement'
export const PATIENTS_CREATE = '/patients/create'
export const PATIENT_CARDS_UPLOAD = '/patient-cards/upload'
export const PATIENT_CARDS_PRESIGNED_UPLOAD = '/patient-cards/presigned-upload'
export const PATIENT_CARDS_COMPLETE_UPLOAD = '/patient-cards/complete-upload'
export const PATIENT_CARDS = '/patient-cards/patient/'
export const PATIENT_CARDS_FETCH = '/patient-cards'
export const SEND_UPLOAD_CARD_LINK = '/auth/send-insurance-upload-link'

export const getPatientCardsRoute = (patientId: string): string =>
  `${PATIENT_CARDS}${patientId}`

export const getUserInfoById = (userId: string): string =>
  `${USERS}/${userId}/details`

export const getUserBillingDetailsRoute = (id: string): string =>
  `${USER_BILLING_DETAILS}?userId=${id}`

export const getConsentPdfRoute = (
  patientId: string,
  encryptedLicenseKeyEhrId: string = null
): string => `/patients/${patientId}/consent-pdf/${encryptedLicenseKeyEhrId}`

export const getSafetyPlanPdfRoute = (
  patientId: string,
  documentId: string
): string => `/patients/${patientId}/safety-plan-pdf/${documentId}`

export const sendConsentEmailRoute = (patientId: string): string =>
  `/patients/${patientId}/consent`

export const getUserB2BDetails = (email: string): string =>
  `users/exists?email=${encodeURIComponent(email)}`

export const updateUserRoute = (userId: string): string => `users/${userId}`

export const getAttachPartnershipRoute = (userId: string): string =>
  `${USERS}/${userId}/attach-partnership`

export const verifyCodeConsentRoute = (code: string): string =>
  `/patients/consent/${code}/verify`

export const verifyConsentFromVFDRoute = (taskId: string): string =>
  `/patient-tasks/consent/${taskId}/verify`

export const signCodeConsentRoute = (code: string): string =>
  `/patients/consent/${code}/sign`

export const signConsentFromVFDRoute = (taskId: string): string =>
  `/patient-tasks/consent/${taskId}/sign`

export const geTransactionHistoryRoute = (
  responsiblePartyEhrId: number,
  { startDate, endDate }: Record<string, string>
): string =>
  `/payment-receipts?startDate=${startDate}&endDate=${endDate}&responsiblePartyEhrId=${responsiblePartyEhrId}`

export const getPaymentPdfRoute = (paymentId: string): string =>
  `/payment-receipts/${paymentId}/download`

export const getSessionBillingStatementRoute = (params: {
  userId: string
  patientId: string
  ehrVisitId: string
}): string =>
  `${USER_BILLING_STATEMENT}?patientId=${params.patientId}&ehrVisitId=${params.ehrVisitId}&userId=${params.userId}`
